var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _rect, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkShipment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 290,
    viewBox: "0 0 314 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.627 235.462C78.7387 235.462 44.9635 256.621 21.8485 235.462C-3.96264 211.835 28.1939 194.567 28.1939 156.148C28.1939 122.143 -9.29907 83.773 21.8486 65.6621C52.9962 47.5513 71.0484 84.2472 116.166 84.2472C157.586 84.2472 155.091 66.5717 199.007 54.6979C270.868 35.268 313.785 63.1633 313.785 93.5575C313.785 123.952 261.256 141.269 286.837 182.664C321.811 239.258 298.005 275 253.498 275C204.706 275 194.515 235.462 136.627 235.462Z",
    fill: "#DEE9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.521 62.5342H89.5333V183.492V214.401H240.988V183.492V92.0008V62.5342H211.521Z",
    fill: "#347AF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.321 48.3335H75.3334V168.291V199.2H224.788V168.291V76.8002V48.3335H196.321Z",
    fill: "#4B87F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225 189.599H75V199.199H225V189.599Z",
    fill: "#A9C9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225 131.999H75V141.599H225V131.999Z",
    fill: "#A9C9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225 112.799H75V122.399H225V112.799Z",
    fill: "#A9C9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225 93.5991H75V103.199H225V93.5991Z",
    fill: "#A9C9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225 74.3989H75V83.9989H225V74.3989Z",
    fill: "#A9C9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225 55.1992H75V64.7992H225V55.1992Z",
    fill: "#A9C9FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M225 151.199H75V160.799H225V151.199Z",
    fill: "#A9C9FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M225 47.999H75V57.599H225V47.999Z",
    fill: "#A9C9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225 170.399H75V179.999H225V170.399Z",
    fill: "#A9C9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6 47.999H75V199.199H84.6V47.999Z",
    fill: "#A9C9FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111 47.999H101.4V199.199H111V47.999Z",
    fill: "#A9C9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225 47.999H215.4V199.199H225V47.999Z",
    fill: "#A9C9FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 172.529,
    width: 63.4377,
    height: 63.4377,
    rx: 31.7189,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 208.654V213.059H242.408V208.654H239.471V213.059C239.471 214.674 240.793 215.996 242.408 215.996H260.03C261.645 215.996 262.967 214.674 262.967 213.059V208.654H260.03ZM243.877 199.843L245.947 201.913L249.751 198.125V210.122H252.688V198.125L256.491 201.913L258.561 199.843L251.219 192.5L243.877 199.843Z",
    fill: "#266EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkShipment);
export default __webpack_public_path__ + "static/media/BulkShipment.47a34a5e148efe4e0a04a1ebbfb4c163.svg";
export { ForwardRef as ReactComponent };